export default __webpack_public_path__ + "static/media/facemoji.923070af.png";